/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SDCCAPayments.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SDCCA_PAYMENTS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDCCAPAYMENTS/FETCH_SDCCA_PAYMENTS`
);

export { FETCH_SDCCA_PAYMENTS };
